
class InkRadios extends HTMLElement {
  constructor() {
    super();
    this.optionLegend = this.querySelector('fieldset.product-form__input').querySelector('legend').querySelector('span');
    this.inkRadios = this.querySelectorAll('input[type="radio"]');
    this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.querySelector('.product-form__error-message');

    this.addEventListener('change', this.onRadioChange.bind(this));
  }

  onRadioChange(e) {
    this.clearError();
    this.updateOptionLegend();
    this.updateMedia();
    this.updateURL()
  }

  clearError() {
    this.errorWrapper.setAttribute('hidden', '');
    this.errorMessage.textContent = '';
  }

  updateOptionLegend() {
    this.optionLegend.innerText = this.getSelectedInk().value;
  }

  updateMedia() {
    const media = this.getSelectedInk().dataset.inkImage;
    if (!media) return;

    const mediaGallery = document.querySelector('media-gallery');

    if (mediaGallery) {
      mediaGallery.setActiveMedia(media, true, false)
      if (window.matchMedia(`(min-width: 40em)`).matches) return;
      window.scroll({
        top: mediaGallery.offsetTop,
        behavior: 'smooth'
      });
    }
  }

  updateURL() {

  }

  getSelectedInk() {
    return Array.from(this.inkRadios).find(ink => ink.checked === true);
  }
}

customElements.define('ink-radios', InkRadios);
